import React from 'react';
import Heading from '@atlaskit/heading';
import SuccessContainer from './SuccessContainer';
export default (function () {
  return /*#__PURE__*/React.createElement(SuccessContainer, null, /*#__PURE__*/React.createElement(Heading, {
    size: "xsmall"
  }, "Thanks for your feedback"));
});